module.exports = __webpack_public_path__ + "static/media/services-consultation.f0efc36a.png";